export default "__VITE_ASSET__Bfh_BKOf__"